import type { ReactNode } from 'react';

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function AdminPageHeader({ title, subtitle, action }: AdminPageHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-zooindigo">{title}</h1>
        {subtitle === undefined ? null : (
          <p className="text-zoomuted text-sm mt-1">{subtitle}</p>
        )}
      </div>
      {action === undefined ? null : action}
    </div>
  );
}
